import { Routes } from '../App/Routes';

/**
 * Redirect to the dashboard App
 * @returns null
 */
export const Dashboard = (): null => {
  window.location.href = process.env.REACT_APP_ACCORDO_BASE_URL ?? `/ui${Routes.console}`;
  return null;
};
